import { createSlice } from "@reduxjs/toolkit";
import { getCustomersAPI } from "../../api/customer";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const getAllCustomerSlice = createSlice({
  name: "getAllCustomer",
  initialState: data,
  reducers: {
   getAllCustomerSlice(state) {
      state.isLoading = true;
    },
   getAllCustomerSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getAllCustomerSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   getAllCustomerSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getAllCustomersHandler: any = (search:any,page:any,limit:any,selectedStatus:any,sortField:any,sortDirection:any) => async (dispatch: any) => {
  try {
    dispatch(getAllCustomerAction.getAllCustomerSlice());
    const response: any = await getCustomersAPI(search,page,limit,selectedStatus,sortField,sortDirection);
    
    dispatch(getAllCustomerAction.getAllCustomerSliceSuccess(response));
  } catch (e: any) {
    dispatch(getAllCustomerAction.getAllCustomerSliceFailure(e?.response?.data));
  }
};
export default getAllCustomerSlice.reducer;
export const getAllCustomerAction = getAllCustomerSlice.actions;
